import logo_icon from './logo_icon1.svg';
import reservation_dashboard_placeholder from './reservation-dashboard-placeholder.png';
import phone_placeholder from './phone-placeholder.jpg';
import dash_screen from "./dash-screen.png";
import bookings from "./bookings.jpg"
import googleLogo from "./logo-google.svg";

const assets = {
  logo_icon,
  reservation_dashboard_placeholder,
  phone_placeholder,
  dash_screen,
  bookings,
  googleLogo
};

export default assets;